import { render, staticRenderFns } from "./demo-greeting.vue?vue&type=template&id=c9b74706&scoped=true&"
import script from "./demo-greeting.vue?vue&type=script&lang=js&"
export * from "./demo-greeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b74706",
  null
  
)

export default component.exports